import { ResolveFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { BrandsListComponent } from '@adm-web-app/modules/brands/pages/list/brand-list.component';
import { BrandEditComponent } from '@adm-web-app/modules/brands/pages/edit/brand-edit.component';
import { BrandModel, HxBrandService } from 'hx-services';

const brandResolveFn: ResolveFn<BrandModel> = route => inject(HxBrandService).getBrandById(Number(route.paramMap.get('brandId')));

export const brandsRoutes: Routes = [
  {
    path: '', component: BrandsListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: BrandEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':brandId/edit', component: BrandEditComponent,
    resolve: {
      model: brandResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
